import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatErr } from "../lib/api";

export default function CustomPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [form, setForm] = useState({});
  const [done, setDone] = useState(false);
  useEffect(()=>{ api.get(`/pages/${slug}`).then(r=>setPage(r.data)).catch(()=>setPage({title:"Not found", body:"", form_fields:[]})); }, [slug]);
  if (!page) return <div className="py-32 text-center text-gray-400">Loading…</div>;
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post(`/pages/${slug}/submit`, form); setDone(true); toast.success("Submitted"); }
    catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <h1 className="font-display text-5xl text-dark tracking-tight mb-6">{page.title}</h1>
      <div className="text-gray-700 leading-relaxed whitespace-pre-line">{page.body}</div>
      {page.form_fields?.length > 0 && !done && (
        <form onSubmit={submit} className="card-luxe p-8 mt-10 space-y-4">
          {page.form_fields.map((f, i) => (
            <div key={i}>
              <div className="overline mb-2">{f.label}</div>
              {f.type === "textarea" ? <textarea required={f.required} rows={4} className="input-box resize-none" onChange={(e)=>setForm({...form, [f.name]: e.target.value})}/>
                : <input required={f.required} type={f.type||"text"} placeholder={f.placeholder||""} className="input-box" onChange={(e)=>setForm({...form, [f.name]: e.target.value})}/>}
            </div>
          ))}
          <button className="btn-primary">Submit</button>
        </form>
      )}
      {done && <div className="card-luxe p-8 mt-10 text-center text-gray-700">Thank you. Your submission has been received.</div>}
    </div>
  );
}
